import { Popover } from 'rsuite';
import { cssVars } from '@/app/styles';
import styled from 'styled-components';

export const StyledBalloon = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
`;

export const PopoverContentWrapper = styled.div`
  width: 400px;
`;

export const CopyButtonContent = styled.div`
  line-height: 1;
  font-size: 14px;
  height: 14px;
  font-family: 'Nunito Sans', sans-serif; /* overrides internal rsuite font */
  font-weight: 700;
  color: ${cssVars.color.rentalscapeBlue};
`;

export const StyledPopover = styled(Popover)`
  padding: 30px !important;
  /* Hides the tooltip */
  transform: translateX(14px) !important;

  .rs-popover-title {
    font-size: 16px;
    font-weight: 600;
  }

  .rs-popover-arrow {
    display: none;
  }
`;
